import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@/components/ui/empty";
import { IconBadge } from "@/components/IconBadge";

export function EmptyState({ icon, tone = "slate", title, message, action = null }) {
  return (
    <Empty className="border border-dashed border-border">
      <EmptyHeader>
        {icon ? <IconBadge icon={icon} tone={tone} size="lg" className="mb-2" /> : null}
        <EmptyTitle>{title}</EmptyTitle>
        {message ? <EmptyDescription>{message}</EmptyDescription> : null}
      </EmptyHeader>
      {action ? <EmptyContent>{action}</EmptyContent> : null}
    </Empty>
  );
}
